module.exports = __webpack_public_path__ + "fa-brands-400.0fbfc862056bad982c93.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-brands-400.ttf
// module id = ./src/assets/webfonts/fa-brands-400.ttf
// module chunks = styles